module.exports = __webpack_public_path__ + "img/u382.b7fb6256.png";